import { loadPastMaintenancesFailed, loadPastMaintenancesSucceeded } from './actionCreators';
import { ActionTypes } from './actionTypes';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { MaintenanceRequester, type PastMaintenancesMaps } from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

import Alert from '@cobliteam/ui/components/Alert';

const env = Environment.getInstance().getEnvironment();

export const maintenanceRequester = new MaintenanceRequester({
  host: env.herbieApiHost,
});

export function* requestPastMaintenancesSaga() {
  try {
    const pastMaintenancesMap: PastMaintenancesMaps = yield call(maintenanceRequester.loadPastMaintenances);
    yield put(loadPastMaintenancesSucceeded(pastMaintenancesMap));
  } catch (err) {
    yield put(loadPastMaintenancesFailed());
    Alert.error('Houve um erro, tente novamente mais tarde.');
  }
}

export function* PastMaintenancesSagasListener() {
  yield all([takeLatest(ActionTypes.LOAD_PAST_MAINTENANCES_REQUEST, requestPastMaintenancesSaga)]);
}
